import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AccommodationType from './accommodation-type';
import AccommodationTypeDetail from './accommodation-type-detail';
import AccommodationTypeUpdate from './accommodation-type-update';
import AccommodationTypeDeleteDialog from './accommodation-type-delete-dialog';

const AccommodationTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AccommodationType />} />
    <Route path="new" element={<AccommodationTypeUpdate />} />
    <Route path=":id">
      <Route index element={<AccommodationTypeDetail />} />
      <Route path="edit" element={<AccommodationTypeUpdate />} />
      <Route path="delete" element={<AccommodationTypeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AccommodationTypeRoutes;
